// `show` — the related view IS the step ("review the shortages before you
// continue"); `acknowledge` keeps Next waiting, `pick_row` works as in a panel.

import { ContextPanel } from '../context/ContextPanels'
import { Check, type StepProps } from './common'

export default function ShowStep({ ctl, handheld }: StepProps) {
  const { step, ui } = ctl
  if (!step?.content) return null
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <ContextPanel ctl={ctl} panel={step.content} layout="full" />
      {step.acknowledge && (
        <Check checked={ui.ack} onChange={v => ctl.setUi({ ack: v })} handheld={handheld}
          label="I have reviewed this" hook="_acknowledge" />
      )}
    </div>
  )
}
